import React from 'react';
import { motion } from 'framer-motion';
type Priority = 'High' | 'Medium' | 'Low';
interface PrioritySelectorProps {
  selected: Priority;
  onSelect: (priority: Priority) => void;
}
export function PrioritySelector({
  selected,
  onSelect
}: PrioritySelectorProps) {
  const priorities: Priority[] = ['Low', 'Medium', 'High'];
  const getColor = (priority: Priority, isSelected: boolean) => {
    if (!isSelected) return 'bg-gray-300 dark:bg-gray-600';
    switch (priority) {
      case 'High':
        return 'bg-red-500';
      case 'Medium':
        return 'bg-yellow-500';
      case 'Low':
        return 'bg-green-500';
      default:
        return 'bg-gray-300';
    }
  };
  return <div className="flex gap-2 bg-gray-100 dark:bg-gray-800 p-1 rounded-2xl" data-id="element-442">
      {priorities.map(priority => <motion.button key={priority} type="button" whileTap={{
      scale: 0.95
    }} onClick={() => onSelect(priority)} className={`
            flex-1 py-2 rounded-xl font-fredoka font-bold text-sm transition-all
            ${selected === priority ? 'bg-white dark:bg-[#252936] shadow-sm text-game-dark dark:text-white' : 'text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300'}
          `} data-id="element-443">
          <div className="flex items-center justify-center gap-2" data-id="element-444">
            <div className={`w-2 h-2 rounded-full ${getColor(priority, selected === priority)}`} data-id="element-445" />
            {priority}
          </div>
        </motion.button>)}
    </div>;
}